<template>
  <div class="menus-investment">
    <Header class="menus-top"></Header>
    <div class="content">
      <div class="logo-box">
        <span class="logo-name">CRIC</span>
        <span class="logo-title">投资决策</span>

         <div class="box_header-right">
          <div class="active-index">{{activeIndex + 1}}</div>
          <div class="border">—</div>
          <div class="length">{{cityList.length}}</div>
        </div>
      </div>

      <div class="cities">
        <div
          v-for="(city, index) in cityList"
          :key="index"
          class="city cursor"
          :class="activeIndex === index ? 'activeCity' : ''"
          @mouseenter="mouseEnterMethod(index)"
          @mouseleave="mouseLeaveMethod(index)"
          @click="openToPage(city.url)"
        >
          <img v-if="activeIndex === index" class="city-hover" :src="require('@assets/img/investments/city-border-hover.png')">
          <div class="city-img-box">
            <img draggable="false" :src="require('@assets/img/investments/city-border.png')" class="city-border" />
            <img draggable="false" class="city-img" :src="city.imgUrl" />
            <div class="city-name">{{city.name}}</div>
            <img draggable="false" :class="activeIndex === index ? 'animation-first' : ''" :src="require('@assets/img/investments/arrow.png')" class="city-arrow city-arrow-1">
            <img draggable="false" :class="activeIndex === index ? 'animation-second' : ''" v-if="activeIndex === index" :src="require('@assets/img/investments/arrow.png')" class="city-arrow city-arrow-2">
            <img draggable="false" :class="activeIndex === index ? 'animation-third' : ''" v-if="activeIndex === index" :src="require('@assets/img/investments/arrow.png')" class="city-arrow city-arrow-3">
          </div>
        </div>
      </div>
      <!-- <div class="indexBar">
        <div class="index-tools">
          <span class="index-tools__index">{{activeIndex + 1}}</span>
          / {{cityList.length}}
        </div>
        <div class="slider">
          <div
            class="active-slider"
            :style="{width: `${(activeIndex + 1) / cityList.length * 100}%`}"
          ></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";
import { cityList } from "./schema";

export default {
  mounted() {
    this.startLoop();
  },
  data() {
    return {
      cityList,
      activeIndex: 0,
      loopTime: 3000, // 时间间隔
      timer: null
    };
  },
  components: {
    Header: () => import('@/components/header.vue')
  },
  methods: {
    getCurrentDate() {
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return `${year}年${month}月${day}日`;
    },
    setActiveIndex(index) {
      this.activeIndex = index;
    },
    startLoop() {
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        let index = this.activeIndex + 1;
        index = (this.activeIndex + 1) % this.cityList.length;
        this.setActiveIndex(index);
      }, this.loopTime);
    },
    stopLoop() {
      this.timer && clearInterval(this.timer);
    },
    mouseEnterMethod(index) {
      this.stopLoop();
      this.setActiveIndex(index);
    },
    mouseLeaveMethod(index) {
      this.startLoop();
    },
    openToPage(url) {
      window.open(url)
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes animationFirst {
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0.6;
  }
  66% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
@keyframes animationSecond {
  0% {
    opacity: 0.6;
  }
  33% {
    opacity: 0.3;
  }
  66% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}
@keyframes animationThird {
  0% {
    opacity: 0.3;
  }
  33% {
    opacity: 1;
  }
  66% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.3;
  }
}
.menus-investment {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/img/menus/background.png");
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .animation-first {
    animation: animationFirst 1.5s infinite;
  }

  .animation-second {
    animation: animationSecond 1.5s infinite;
  }

  .animation-third {
    animation: animationThird 1.5s infinite;
  }

  .menus-top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  .content {
    width: 100%;
    height: 100%;
    padding: 0 2%;
    position: relative;
    overflow: auto;

    .logo-box {
      text-align: left;
      height: 18%;
      padding-left: 24px;
      display: flex;
      align-items: flex-end;
      padding-bottom: 24px;
      position: relative;

      .logo-name {
        color: #bf1521;
        font-size: 40px;
        font-weight: 800;
        margin-right: 16px;
      }

      .logo-title {
        color: #fff;
        font-size: 40px;
      }
    }

    .cities {
      display: flex;
      flex-wrap: wrap;
      gap: 48px 0;

      .activeCity {
        .city-img {
          opacity: 1 !important;
        }
      }

      .city-hover {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }

      .city {
        width: 20%;
        padding: 24px;
        box-sizing: border-box;
        transition: opacity 0.3s;
        position: relative;
      }

      .city-border {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .city-img-box {
        width: 100%;
        // height: 100%;
        border-radius: 4px;
        position: relative;
      }

      .city-img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        opacity: 0.5;
      }

      .city-name {
        position: absolute;
        left: 15px;
        bottom: 0;
        padding: 4px 12px;
        background: #0071e7;
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
      }

      .city-arrow {
        position: absolute;
        bottom: 10px;
        width: 10px;
        height: 13px;
      }
      .city-arrow-1 {
        right: 10px;
        opacity: 1;
      }
      .city-arrow-2 {
        right: 22px;
        opacity: 0.6;
      }
      .city-arrow-3 {
        right: 34px;
        opacity: 0.3;
      }
    }
  }

  .indexBar {
    height: 10%;
    width: calc(~"100% - 48px");
    margin: 0 24px;
    position: relative;

    .index-tools {
      color: #fff;
      font-size: 16px;
      float: right;

      .index-tools__index {
        color: #00dcff;
        font-size: 24px;
      }
    }

    .slider {
      width: 100%;
      height: 2px;
      background: linear-gradient(
        90deg,
        rgba(61, 186, 255, 1) 0%,
        rgba(39, 0, 255, 1) 100%
      );
      position: absolute;
      bottom: 50%;
      left: 0;
      border-radius: 2px;
    }

    .active-slider {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      border-radius: 2px;
      // width: 30%;
      background: linear-gradient(
        90deg,
        rgba(26, 0, 230, 1) 0%,
        rgba(255, 61, 200, 1) 100%
      );
      transition: all 0.5s;

      &::after {
        content: "";
        display: block;
        width: 8px;
        height: 8px;
        background: rgba(255, 65, 61, 1);
        box-shadow: 0px 0px 9px 0px rgba(255, 98, 98, 1);
        border: 1px solid rgba(255, 171, 171, 1);
        border-radius: 50%;
        position: absolute;
        right: -4px;
        top: -4px;
      }
    }
  }
}

/*滚动条整体部分,必须要设置*/
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  background-color: transparent;
}

.box_header-right {
      color: #fff;
      font-size: 14px;
      font-weight: 100;
      color: rgba(255, 255, 255, .3);
      line-height: 14px;
      position: absolute;
      right: 24px;

      div {
        width: 14px;
        text-align: center;
      }

      &::before {
        content: "";
        position: absolute;
        left: -16px;
        top: 50%;
        transform: translate(-100%, -50%);

        width: 240px;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
      }

      // &::after {
      //   content: "";
      //   position: absolute;
      //   left: 50%;
      //   bottom: -16px;
      //   transform: translate(-50%, 100%);

      //   width: 1px;
      //   height: 48px;
      //   background: rgba(255, 255, 255, 0.3);
      // }
    }
</style>